export type Maybe<T> = T | null | undefined;

export const ACTIVITY_MEDIA_HEIGHT = 230;
